import { createSelector } from '@reduxjs/toolkit'
import { ApplicationState } from 'redux/Stores/types'
import { TOrganizationalUnit } from 'types/GlobalOrganizationalUnit'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

/**
 * Base selector for organizational units state
 */
const selectOrganizationalUnitsState = (state: ApplicationState) =>
  state.OrganizationalUnitsStore

/**
 * Select organizational units data object
 */
export const selectOrganizationalUnits = createSelector(
  [selectOrganizationalUnitsState],
  (organizationalUnitsState) => organizationalUnitsState.data
)

/**
 * Select organizational units as array
 */
export const selectOrganizationalUnitsArray = createSelector(
  [selectOrganizationalUnits],
  (organizationalUnits) =>
    Object.values(organizationalUnits).sort((a, b) =>
      sortAlphabeticalAsc(a.name, b.name)
    )
)

/**
 * Select default organizational units
 */
export const selectDefaultOrganizationalUnits = createSelector(
  [selectOrganizationalUnitsState],
  (organizationalUnitsState) => organizationalUnitsState.default
)

/**
 * Select full access enum
 */
export const selectFullAccessEnum = createSelector(
  [selectOrganizationalUnitsState],
  (organizationalUnitsState) => organizationalUnitsState.fullAccessEnum
)

/**
 * Select loading state
 */
export const selectOrganizationalUnitsFetched = createSelector(
  [selectOrganizationalUnitsState],
  (organizationalUnitsState) => organizationalUnitsState.fetched
)

/**
 * Select organizational unit by ID
 */
export const selectOrganizationalUnitById = (id: string) =>
  createSelector(
    [selectOrganizationalUnits],
    (organizationalUnits): TOrganizationalUnit | undefined =>
      organizationalUnits[id]
  )
